import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.css';
import { useAuth } from '../../../Layouts/context/Authcontext';
import Barwiththreeset from '../../../DashboardComponents/Barwiththreeset';
import EmployeeErrorChart from '../TeamLeaderDashboard/EmployeeErrorChart';
import DashboardWrapperProductivity from '../../../DashboardComponents/DashboardWrapperProductivity';
import BasicDonutChart from '../../../DashboardComponents/BasicDonutChart';
import { FaChartLine, FaUserCheck, FaTasks, FaClipboardList } from 'react-icons/fa';
import AMAttendancePercentage from '../QualityAuditor/AMAttendancePercentage';
import { TailSpin } from 'react-loader-spinner';
import TATMetricsCard from './TATMetricsCard';
import CustomDateFilter from './customDateFilter';
// import AttendanceFilter from './AttendanceFilter';
import CompareDateRanges from './CompareDateRange';
import InventoryFilter from './InventoryFilter';
import AttendanceDateRangeFilter from './AttendanceDateRange';
import ErrorFilter from './ErrorFilter';
import { getRoundRobinBaseUrl } from '../../../../loadBalancer';

function AMDMProductivityTab1() {
  const isDark = useSelector((state) => state.themeConfig.theme === 'dark' || state.themeConfig.isDarkMode);
  const { accessToken } = useAuth();

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [filteredData, setFilteredData] = useState(null);
  const [selectedOption, setSelectedOption] = useState('type1'); // Default selection for radio button
  const [errorInventory, setErrorInventory] = useState(null);
  const [errorLeaves, setErrorLeaves] = useState(null);
  const [inventoryChartData, setInventoryChartData] = useState(null);
  const [selectedInventoryDate, setSelectedInventoryDate] = useState(null); // Default date
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [totalLeaves, setTotalLeaves] = useState(0);
  const [individualLeaves, setIndividualLeaves] = useState([]);
  const [top5Errors, setTop5Errors] = useState([]);
  const [top5Employees, setTop5Employees] = useState([]);
  const [isLoadingErrors, setIsLoadingErrors] = useState(true);
  const [errorLoading, setErrorLoading] = useState(null);
  const [attendanceData, setAttendanceData] = useState({
    MTD: '0%',
    YTD: '0%',
    previousWeek: '0%',
    previousDay: '0%',
    leavesTaken: 0,
  });

  //Loding State
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [isLoadingInventory, setIsLoadingInventory] = useState(true);
  const [isLoadingAttendance, setIsLoadingAttendance] = useState(true);
  const [isLoadingLeaves, setIsLoadingLeaves] = useState(true);
  const [isLoadingCustomDate, setIsLoadingCustomDate] = useState(false);

  // Selection States
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedScope, setSelectedScope] = useState(null);
  const [selectedInventoryClient, setSelectedInventoryClient] = useState(null);
  const [selectedInventoryScope, setSelectedInventoryScope] = useState(null);
  const [selectedErrorClient, setSelectedErrorClient] = useState(null);
  const [selectedErrorScope, setSelectedErrorScope] = useState(null);

  // Calculate the first day of the current month in UTC
  const firstDayOfMonth = new Date(Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), 1));
  // Get today's date in UTC
  const today = new Date(Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate()));

  // Initialize state with the default date range
  const [selectedDate, setSelectedDate] = useState([firstDayOfMonth, today]);
  const [dateRange, setDateRange] = useState([firstDayOfMonth, today]);
  const [inventoryDateRange, setInventoryDateRange] = useState([firstDayOfMonth, today]);
  const [errorDateRange, setErrorDateRange] = useState([firstDayOfMonth, today]);
  const [dataType, setDataType] = useState('Epr'); // default to "Epr"
  const [showLeavesModal, setShowLeavesModal] = useState(false);

  // Set default dates on component mount
  useEffect(() => {
    const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    const today = new Date();
    setStartDate(formatDate(firstDayOfMonth));
    setEndDate(formatDate(today));
  }, []);

  const cardIcons = [
    { icon: <FaChartLine className="text-2xl transform rotate-10" /> },
    { icon: <FaUserCheck className="text-2xl transform scale-110" /> },
    { icon: <FaTasks className="text-2xl transform -rotate-10" /> },
    { icon: <FaClipboardList className="text-2xl transform scale-90" /> },
  ];

  // Function to format dates as MM/DD/YYYY
  // const formatDate = (date) => {
  //   let month = (date.getMonth() + 1).toString().padStart(2, '0'); // Ensure 2-digit month
  //   let day = date.getDate().toString().padStart(2, '0'); // Ensure 2-digit day
  //   let year = date.getFullYear();
  //   return `${month}/${day}/${year}`; // Return MM/DD/YYYY
  // };

  const formatDate = (date) => {
    if (!date || !(date instanceof Date)) return ''; // or return null if you prefer

    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');
    let year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const formatTop5Errors = (errors) => {
    return {
      series: errors.map((error) => error.count),
      label: errors.map((error) => error.errorCategory),
    };
  };

  const formatTop5Employees = (employees) => {
    return employees.map((employee, index) => ({
      id: index + 1, // Assigning a unique ID if missing
      name: employee.employeeName,
      errors: employee.count,
    }));
  };

  // Fetch API data without query parameters
  const fetchData = async () => {
    if (!accessToken) return;
    setIsLoadingData(true);
    try {
      let baseUrls = getRoundRobinBaseUrl();
      const response = await axios.get(`${baseUrls}/managerDashboard/getProductivity`, {
        params: { type: dataType }, // pass type as query param
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      setData(response.data.results);
    } catch (err) {
      setError('Failed to fetch data');
    } finally {
      setIsLoadingData(false);
    }
  };

  // ** Fetch API - Custom Date Productivity **
  const fetchCustomDateProductivity = async () => {
    let baseUrls = getRoundRobinBaseUrl();
    if (!accessToken) return;
    setIsLoadingCustomDate(true);
    setError(null);

    let url = `${baseUrls}/managerDashboard/getCustomDateProduction`;

    const params = {
      startDate: formatDate(dateRange[0]),
      endDate: formatDate(dateRange[1]),
      type: dataType,
    };

    if (selectedClient) params.clientId = selectedClient;
    if (selectedScope) params.scopeId = selectedScope;

    try {
      const response = await axios.get(url, {
        params,
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      if (response.data.success) {
        setFilteredData(response.data.data);
      } else {
        setError('Failed to fetch data');
      }
    } catch (err) {
      setError('An error occurred while fetching data');
    } finally {
      setIsLoadingCustomDate(false);
    }
  };

  const fetchInventoryData = async () => {
    let baseUrls = getRoundRobinBaseUrl();
    if (!accessToken) return;
    setIsLoadingInventory(true);
    setErrorInventory(null);

    let url = `${baseUrls}/managerDashboard/getInventoryData`;

    const params = {
      inventoryStartDate: formatDate(inventoryDateRange[0]),
      inventoryEndDate: formatDate(inventoryDateRange[1]),
      type: dataType,
    };

    // Format selected date range for API request
    if (selectedInventoryDate && selectedInventoryDate.length > 0) {
      params.date = selectedInventoryDate.map((date) => formatDate(date)).join(','); // Convert to MM/DD/YYYY
    }

    // Include selected filters
    if (selectedInventoryClient) params.clientId = selectedInventoryClient;
    if (selectedInventoryScope) params.scopeId = selectedInventoryScope;
    if (selectedOption) params.type = selectedOption;

    try {
      const response = await axios.get(url, {
        params, // Passing query parameters dynamically
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      if (response.data.success) {
        setInventoryChartData(transformInventoryData(response.data.data));
      } else {
        setErrorInventory('Failed to fetch inventory data');
      }
    } catch (err) {
      setErrorInventory('An error occurred while fetching inventory data');
    } finally {
      setIsLoadingInventory(false);
    }
  };

  // Fetch Attendance Data
  const fetchTop5Errors = async () => {
    if (!accessToken) return;
    setIsLoadingErrors(true);

    // Build the parameters object dynamically based on selected filters
    const params = {};

    if (selectedErrorClient) params.clientId = selectedErrorClient;
    if (selectedErrorScope) params.scopeId = selectedErrorScope;
    if (errorDateRange && errorDateRange.length > 0) {
      params.startDate = formatDate(errorDateRange[0]);
      params.endDate = formatDate(errorDateRange[1]);
    }

    try {
      let baseUrls = getRoundRobinBaseUrl();
      const response = await axios.get(`${baseUrls}/managerDashboard/getTop5Error`, {
        params, // Passing the query parameters dynamically
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      if (response.data) {
        setTop5Errors(formatTop5Errors(response.data.top5Errors || []));
        setTop5Employees(formatTop5Employees(response.data.top5Employees || []));
      } else {
        setErrorLoading('Failed to fetch top errors data');
      }
    } catch (error) {
      setErrorLoading('An error occurred while fetching top errors data');
    } finally {
      setIsLoadingErrors(false);
    }
  };

  // const fetchAttendanceData = async () => {
  //   if (!accessToken) return;
  //   setIsLoadingAttendance(true);
  //   try {
  //     let baseUrls = getRoundRobinBaseUrl();
  //     const response = await axios.get(`${baseUrls}/managerDashboard/getAttendance`, {
  //       headers: { Authorization: `Bearer ${accessToken}` },
  //     });

  //     if (response.data.success) {
  //       const data = response.data.data;

  //       setAttendanceData({
  //         MTD: data.mtdAttendance?.percentage || '0%',
  //         YTD: data.ytdAttendance?.percentage || '0%',
  //         previousWeek: data.previousWeekAttendance?.percentage || '0%',
  //         previousDay: data.previousDayAttendance?.percentage || '0%',
  //         // Assuming leavesTaken is part of the response; adjust if necessary
  //         leavesTaken: data.leavesTaken || 0,
  //       });
  //     } else {
  //       console.error('Attendance API Error:', response.data.message);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching Attendance:', error);
  //   } finally {
  //     setIsLoadingAttendance(false);
  //   }
  // };

  // const fetchLeavesData = async (start, end) => {
  //   setIsLoadingLeaves(true);
  //   setErrorLeaves(null);
  //   try {
  //     let baseUrls = getRoundRobinBaseUrl();
  //     const response = await axios.get(`${baseUrls}/managerDashboard/getLeaves`, {
  //       params: { startDate: start, endDate: end },
  //       headers: { Authorization: `Bearer ${accessToken}` },
  //     });

  //     if (response.data.success) {
  //       const leaveData = response.data.data; // ✅ Correct
  //       setTotalLeaves(leaveData.totalLeaves || 0);
  //       setIndividualLeaves(leaveData.individualLeaves || []);
  //     } else {
  //       setErrorLeaves('Failed to fetch data');
  //     }
  //   } catch (err) {
  //     setErrorLeaves('An error occurred');
  //   } finally {
  //     setIsLoadingLeaves(false);
  //   }
  // };

  const transformInventoryData = (data) => {
    const categories = data.map((item) => item._id); // X-axis labels (_id)
    const uploadedCounts = data.map((item) => item.totalUploadedCount); // Y-axis for "Total Uploaded Count"
    const allocatedCounts = data.map((item) => item.totalAllocatedCount); // Y-axis for "Total Allocated Count"
    const completedCounts = data.map((item) => item.totalCompletedCount); // Y-axis for "Total Completed Count"

    return {
      series: [
        {
          name: 'Total Uploaded Count',
          data: uploadedCounts,
        },
        {
          name: 'Total Allocated Count',
          data: allocatedCounts,
        },
        {
          name: 'Total Completed Count',
          data: completedCounts,
        },
      ],
      categories,
    };
  };

  useEffect(() => {
    fetchData();
  }, [accessToken, dataType]);

  // useEffect(() => {
  //   if (dateRange.length === 2) {
  //     const [start, end] = dateRange;
  //     fetchLeavesData(formatDate(start), formatDate(end));
  //   }
  // }, [dateRange]);

  useEffect(() => {
    if (dateRange.length === 2) {
      fetchCustomDateProductivity(dateRange[0], dateRange[1]);
    }
  }, [accessToken, selectedClient, selectedScope, dateRange, dataType]);

  useEffect(() => {
    fetchInventoryData();
  }, [
    accessToken,
    selectedInventoryClient,
    selectedInventoryScope,
    selectedInventoryDate,
    selectedOption,
    inventoryDateRange,
    dataType,
  ]);

  // useEffect(() => {
  //   fetchAttendanceData();
  // }, [accessToken]);

  useEffect(() => {
    fetchTop5Errors(); // Re-fetch errors whenever any of the filters change
  }, [selectedErrorClient, selectedErrorScope, errorDateRange, accessToken]);

  // useEffect(() => {
  //   fetchLeavesData(startDate, endDate);
  // }, [startDate, endDate]);

  // ** Handle Date Selection from `Flatpickr` **
  const handleDateChange = (dates) => {
    if (dates.length === 2) {
      setDateRange(dates); // ✅ Update state
    }
  };

  // const handleLeaveDateChange = (selectedDates) => {
  //   if (selectedDates.length === 2) {
  //     const [start, end] = selectedDates;
  //     setStartDate(formatDate(start));
  //     setEndDate(formatDate(end));
  //   }
  // };

  const handleLeaveDateChange = (selectedDates) => {
    if (selectedDates.length === 2) {
      setDateRange(selectedDates);
    }
  };

  // ** Handle Client & Scope Selection from `CustomDateFilter` **
  const handleClientSelect = (clientId) => {
    setSelectedClient(clientId);
  };

  const handleScopeSelect = (scopeId) => {
    setSelectedScope(scopeId);
  };

  const handleFromDateSelect = (date) => {
    setDateRange([date, dateRange[1]]);
  };

  const handleToDateSelect = (date) => {
    setDateRange([dateRange[0], date]);
  };

  // ** Handle Client & Scope Selection from `InventoryDateFilter` **
  const handleInventoryClientSelect = (clientId) => {
    setSelectedInventoryClient(clientId);
  };

  const handleInventoryScopeSelect = (scopeId) => {
    setSelectedInventoryScope(scopeId);
  };

  const handleInventoryFromDateSelect = (date) => {
    setInventoryDateRange([date, inventoryDateRange[1]]);
  };

  const handleInventoryToDateSelect = (date) => {
    setInventoryDateRange([inventoryDateRange[0], date]);
  };

  // ** Handle Client & Scope Selection from `CustomDateFilter` **
  const handleErrorClientSelect = (clientId) => {
    setSelectedErrorClient(clientId);
  };

  const handleErrorScopeSelect = (scopeId) => {
    setSelectedErrorScope(scopeId);
  };

  const handleErrorFromDateSelect = (date) => {
    setErrorDateRange([date, errorDateRange[1]]);
  };

  const handleErrorToDateSelect = (date) => {
    setErrorDateRange([errorDateRange[0], date]);
  };

  // const backgroundColors = [
  //     'bg-gradient-to-r from-red-400 via-pink-500 to-purple-500',
  //     'bg-gradient-to-r from-green-400 via-blue-500 to-indigo-500',
  //     'bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500',
  //     'bg-gradient-to-r from-teal-400 via-cyan-500 to-blue-500',
  //     // Add more gradients as needed
  //   ];

  return (
    <div className="space-y-6">
      <div className="flex justify-center mb-6">
        <div className="inline-flex rounded-full shadow-md overflow-hidden border border-gray-300 bg-white">
          <button
            className={`px-4 py-2 text-sm font-medium ${dataType === 'Epr' ? 'bg-[#EE1D23] text-white' : 'text-gray-700'}`}
            onClick={() => setDataType('Epr')}
          >
            Epr
          </button>
          <button
            className={`px-4 py-2 text-sm font-medium ${dataType === 'Biometrics' ? 'bg-[#1A2B5C] text-white' : 'text-gray-700'}`}
            onClick={() => setDataType('Biometrics')}
          >
            Biometrics
          </button>
        </div>
      </div>

      {/* First Row - Display First 4 Data Cards */}
      <div className="grid xl:grid-cols-4 md:grid-cols-2 gap-6">
        {isLoadingData ? (
          <div className="flex justify-center items-center col-span-full">
            <TailSpin height="50" width="50" color="#1A2B5C" ariaLabel="loading" />
          </div>
        ) : (
          data &&
          Object.entries(data)
            .slice(0, 4)
            .map(([key, value], index) => {
              // Set all cards to have the same background color (#1A2B5C)
              const bgGradient = 'bg-[#1A2B5C]'; // Apply the chosen color for all cards
              return (
                <div
                  key={index}
                  className={`p-6 rounded-xl shadow-lg ${bgGradient} text-white border-2 border-dashed border-gray-300 transform transition-transform duration-300 hover:scale-105 hover:shadow-2xl`}
                >
                  {/* Icon and Title */}
                  <div className="flex items-center justify-center space-x-2">
                    <div className={`text-3xl ${cardIcons[index]?.color}`}>{cardIcons[index]?.icon}</div>
                    <h6 className="text-lg font-bold">{key}</h6>
                  </div>
                  {/* Production Percentage */}
                  <div className="flex items-center justify-center mt-4">
                    <p className="text-3xl font-extrabold">{value.productionPercent}</p>
                  </div>
                  {/* Employee Counts */}
                  <div className="flex justify-between mt-3 text-sm font-semibold">
                    <span className="text-red-200">&lt;90%: {value.employeeCounts.below90}</span>
                    <span className="text-green-200">&gt;90%: {value.employeeCounts.range90to99}</span>
                  </div>
                </div>
              );
            })
        )}
      </div>

      {/* Date Filter Section */}
      <div className="grid grid-cols-2 gap-6">
        {/* Custom Date Productivity Section */}
        <div className="p-6 rounded-2xl shadow-lg bg-gradient-to-br from-gray-200 to-blue-50 border border-gray-300 col-span-1 w-full">
          <div className="mb-4 relative z-10">
            <CustomDateFilter
              selectedClientId={handleClientSelect}
              selectedScopeId={handleScopeSelect}
              selectedFromDate={handleFromDateSelect}
              selectedtoDate={handleToDateSelect}
            />
          </div>

          <h6 className="text-xl font-bold text-gray-800 flex items-center mb-4">📅 Custom Date Productivity</h6>

          {/* Date Picker */}
          <Flatpickr
            value={selectedDate}
            onChange={handleDateChange}
            options={{ mode: 'range', dateFormat: 'm/d/Y', defaultDate: [firstDayOfMonth, today], allowInput: true }}
            className="w-full border border-gray-400 rounded-lg p-3 text-md mt-2 bg-white shadow-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />

          {/* Conditional Rendering for Data */}
          {isLoadingCustomDate ? (
            <div className="flex justify-center items-center mt-4">
              <TailSpin height="50" width="50" color="blue" ariaLabel="loading" />
            </div>
          ) : error ? (
            <p className="text-red-500 mt-4">{error}</p>
          ) : filteredData ? (
            <div className="mt-6 p-6 rounded-xl bg-white shadow-md border-l-4 border-[#1A2B5C]">
              <h2 className="text-2xl font-bold text-[#1A2B5C] mb-4">📊 Productivity Report</h2>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                {/* Production % */}
                <div className="p-5 bg-[#1A2B5C]/10 shadow-lg rounded-xl text-center">
                  <p className="text-sm font-medium text-[#1A2B5C]">Production %</p>
                  <p className="text-2xl font-bold text-[#1A2B5C]">{filteredData.productionPercent}</p>
                </div>

                {/* Achieved */}
                <div className="p-5 bg-[#EE1D23]/10 shadow-lg rounded-xl text-center">
                  <p className="text-sm font-medium text-[#EE1D23]">Achieved</p>
                  <p className="text-2xl font-bold text-[#EE1D23]">{filteredData.achieved}</p>
                </div>

                {/* Total Worked Minutes */}
                <div className="p-5 bg-[#808080]/10 shadow-lg rounded-xl text-center">
                  <p className="text-sm font-medium text-[#808080]/105">Total Worked Minutes</p>
                  <p className="text-2xl font-bold text-[#808080]/105">{filteredData.totalWorkedMinutes?.toFixed(2)}</p>
                </div>
              </div>
            </div>
          ) : (
            <p className="text-gray-600 mt-4">No data available for the selected date range.</p>
          )}
        </div>

        {/* Compare Date Ranges - Styled Similarly */}
        <div className="p-6 rounded-2xl shadow-lg bg-gradient-to-br from-gray-50 to-gray-100 border border-gray-300 col-span-1 w-full">
          <CompareDateRanges dataType={dataType} />
        </div>
      </div>

      {/* Third Row - Inventory Card with Radio Buttons */}
      <div className="grid gap-6 mb-6 pt-2 w-full">
        {/* Inventory Section */}
        <div className="grid gap-6 mb-6 pt-2 w-full">
          <div className="p-6 rounded-lg shadow-lg bg-white border border-gray-300">
            <h6 className="text-black text-lg font-bold dark:text-white-light pb-2">📊 Inventory Overview</h6>
            <div className="mb-4 relative z-10">
              <InventoryFilter
                selectedInventoryClientId={handleInventoryClientSelect}
                selectedInventoryScopeId={handleInventoryScopeSelect}
                selectedFromDate={handleInventoryFromDateSelect}
                selectedtoDate={handleInventoryToDateSelect}
              />
            </div>
            {/* Radio Buttons for Inventory Type */}
            <div className="flex items-center space-x-4 mb-4">
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  name="inventoryType"
                  value="type1"
                  checked={selectedOption === 'type1'}
                  onChange={(e) => setSelectedOption(e.target.value)}
                  className="form-radio text-blue-600"
                />
                <span>Type 1</span>
              </label>
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  name="inventoryType"
                  value="type2"
                  checked={selectedOption === 'type2'}
                  onChange={(e) => setSelectedOption(e.target.value)}
                  className="form-radio text-green-600"
                />
                <span>Type 2</span>
              </label>
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  name="inventoryType"
                  value="type3"
                  checked={selectedOption === 'type3'}
                  onChange={(e) => setSelectedOption(e.target.value)}
                  className="form-radio text-purple-600"
                />
                <span>Type 3</span>
              </label>
            </div>
            {/* Display Inventory Data */}
            {isLoadingInventory ? (
              <div className="flex justify-center items-center">
                <TailSpin height="50" width="50" color="blue" ariaLabel="loading" />
              </div>
            ) : errorInventory ? (
              <p className="text-red-500">{errorInventory}</p>
            ) : (
              inventoryChartData && <Barwiththreeset data={inventoryChartData} />
            )}
          </div>
        </div>
      </div>

      {/* Fourth Row - Top 5 Error Categories Card */}
      <div className="panel flex flex-col gap-4 h-4/5">
        <div className="mb-4 relative z-10">
          <ErrorFilter
            selectedErrorClientId={handleErrorClientSelect}
            selectedErrorScopeId={handleErrorScopeSelect}
            selectedErrorFromDate={handleErrorFromDateSelect}
            selectedErrortoDate={handleErrorToDateSelect}
          />
        </div>

        <div className="panel flex justify-between gap-4">
          {/* Error chart section */}
          <div className="panel flex-1 h-full">
            <DashboardWrapperProductivity title="Top 5 Error Categories">
              {isLoadingErrors ? (
                <div className="flex justify-center items-center">
                  <TailSpin height="50" width="50" color="blue" ariaLabel="loading" />
                </div>
              ) : errorLoading ? (
                <p className="text-red-500">{errorLoading}</p>
              ) : (
                <BasicDonutChart data={top5Errors} />
              )}
            </DashboardWrapperProductivity>
          </div>

          {/* Employee Error chart section */}
          <div className="panel flex-1 h-full">
            <DashboardWrapperProductivity title="Top 5 Employees Error wise">
              {isLoadingErrors ? (
                <div className="flex justify-center items-center">
                  <TailSpin height="50" width="50" color="blue" ariaLabel="loading" />
                </div>
              ) : errorLoading ? (
                <p className="text-red-500">{errorLoading}</p>
              ) : (
                <EmployeeErrorChart cardsetdata={top5Employees} />
              )}
            </DashboardWrapperProductivity>
          </div>
        </div>
      </div>

      <div className="space-y-6">
        {/* Attendance Overview Card */}

        <div className="panel space-y-6">
          <h6 className="flex items-center justify-center text-lg font-bold text-gray-900">TAT</h6>
          {/* TAT Metrics Cards */}
          <TATMetricsCard />
        </div>
      </div>
      {/* Modal for Individual Leaves */}
      {showLeavesModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 transition-all duration-500">
          <div
            className="relative bg-white/20 backdrop-blur-3xl border border-white/30 rounded-3xl shadow-2xl p-8 w-full max-w-lg mx-4 transition-all duration-500 ease-in-out"
            style={{
              boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)',
            }}
          >
            <button
              onClick={() => setShowLeavesModal(false)}
              className="absolute top-4 right-4 text-white bg-[#EE1D23] hover:bg-[#c3161c] rounded-full p-2 flex items-center justify-center shadow-lg hover:shadow-red-500/40 transition-all duration-300"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>

            {/* Header */}
            <h3 className="text-2xl font-extrabold text-center text-white drop-shadow mb-6 tracking-wide">Individual Leaves</h3>

            {/* List container */}
            <div className="max-h-80 overflow-y-auto custom-scrollbar px-2">
              <ul className="space-y-3">
                {individualLeaves.map(({ employeeId, leaves }) => (
                  <li
                    key={employeeId}
                    className="bg-white/40 backdrop-blur-xl p-4 rounded-2xl shadow-md border border-white/30 flex justify-between items-center hover:scale-105 transition-transform duration-300"
                  >
                    <div className="text-sm font-medium text-gray-800">
                      <span className="font-semibold text-[#EE1D23]">Emp ID:</span> {employeeId}
                    </div>
                    <div className="text-sm font-bold text-[#1A2B5C]">Leaves: {leaves}</div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AMDMProductivityTab1;